import "./styles/style.css";
import Nav from "./components/Nav";
import Filters from "./components/Filters";
import BookContainer from "./components/BookContainer";
import BookInputCard from "./components/BookInputCard";
import { useState } from "react";
import {useSelector} from "react-redux";
import BookEditCard from "./components/BookEditCard";

function App() {
    let [filter, setFilter] = useState("All");
    let [search, setSearch] = useState("");
    let {bookId} = useSelector(state => state.edit);
    
    return (
        <>
            <Nav handleSearchChange={setSearch} />

            <main className="py-12 2xl:px-6">
                <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
                    <div className="order-2 xl:-order-1">
                        <Filters handleFilterChange={setFilter} />
                        <BookContainer filter={filter} search={search} />
                    </div>

                    { bookId !== undefined ? <BookEditCard bookId={bookId} /> : <BookInputCard /> }
                </div>
            </main>
        </>
    );
}

export default App;
